import React, { useState, useEffect } from 'react'
import { Layout, PageHeader, Spin, Breadcrumb } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Tabs from '~/pages/documentDetails/components/tabs'
import Editor from '~/pages/documentDetails/components/editor'
import PdfReader from '~/components/pdfFileReader'
import NewVersionModal from './components/modal'
import ConnectDocusignModal from './components/modalDocusignConnect'

import { listContract } from '~/states/modules/contract'
import { setInitialFolder, setRollBackFolder } from '~/states/modules/folder'
import {
	getDocumentDetail,
	newVersion,
	updateTextVersion,
	nextStep,
	archive,
	editStep,
	setShowModal,
	setShowConnectModal,
	updateDescription,
	downloadLink,
	getDocumentWordDownload,
	getDocumentCertificate,
	editSigners,
	sendForSigning,
} from '~/states/modules/documentDetail'
import { getGroupList } from '~/states/modules/groups'
import { getCompanyInfo } from '~/states/modules/companies'
import { listTemplate } from '~/states/modules/templates'
import { uploadContextAiFile } from 'states/modules/contextAi'

import { downloadTextDocumentVersion } from 'states/modules/documentDetail'

import styles from '../contracts/index.module.scss'
import MainLayout from '~/components/mainLayout'
import DraftIndicator from './components/draftIndicator'

import HeaderButtons from './components/headerButtons'

const DocumentDetails = () => {
	const dispatch = useDispatch()
	const history = useHistory()

	// request do load document data
	const { id: urlId } = useParams()
	useEffect(() => {
		dispatch(getDocumentDetail({ id: urlId }))
	}, [dispatch, urlId])

	// selects user company info from redux
	const { companyInfo } = useSelector(({ companies }) => companies)

	// selects document data from redux
	const {
		data, // the document details
		loading,
		text,
		textUpdate,
		showModal,
		showConnectModal,
		description,
		loadingSign,
		loadingVersion,
		version_id,
		file,
	} = useSelector(({ documentDetail }) => documentDetail)

	// Workflow	******************************************

	const editCurrentStep = (values) => {
		dispatch(
			editStep({
				id: data.id,
				responsible_group: values.responsible_group,
				due_date: values.dueDate,
			})
		)
	}

	const handleStepCompleted = () => dispatch(nextStep({ id: data.id }))

	const handleStepRejected = () => dispatch(archive({ id: data.id }))

	const { groupsList } = useSelector(({ groups }) => groups)

	useEffect(() => {
		dispatch(getGroupList())
	}, [dispatch])

	const workflowContext = {
		steps: data.workflow?.steps,
		current_step_id: data.workflow?.current_step_id,
		handleStepCompleted: handleStepCompleted,
		handleStepRejected: handleStepRejected,
		editCurrentStep,
		groupsList: groupsList,
	}

	// Signing ************************
	const handleEditSigners = (signers) => {
		dispatch(editSigners({ id: data.id, signers }))
	}

	const handleShowModal = () => {
		dispatch(setShowModal(true))
	}

	const handleCancelModal = () => {
		dispatch(setShowModal(false))
	}

	const { accessFolders } = useSelector(({ folder }) => folder)

	const { id: companyId, baseDocument } = useSelector(
		({ companies }) => companies.companyInfo
	)

	useEffect(() => {
		dispatch(getCompanyInfo())
	}, [dispatch])

	const [filePath, setFilePath] = useState(null)
	const [hasContextAi, setHasContextAi] = useState(false)
	const models = useSelector(({ template }) => template.data)
	const [modelsConfig, setModelsConfig] = useState({})
	const loading_template = useSelector(({ template }) => template.loading)

	useEffect(() => {
		dispatch(listTemplate({ perPage: 1000, published: true }))
	}, [dispatch])

	useEffect(() => {
		for (var j = 0; j < models.length; j++) {
			if (data.document_template_id === models[j].id) {
				setModelsConfig(models[j].config)
			}
		}
		if (data.text_type === 'upload') {
			setFilePath(`${data.company_id}/documents/${data.id}/0.pdf`)
			setHasContextAi(true)
		} else if (data.text_type === '.docx') {
			setFilePath(
				`${data.company_id}/documents/${data.id}/${data.versions[0].id}.pdf`
			)
			setHasContextAi(true)
		} else {
			setHasContextAi(false)
			for (var i = 0; i < models.length; i++) {
				if (modelsConfig.contextAi === true) {
					setFilePath(
						`${data.company_id}/documents/${data.id}/context/context_ai.pdf`
					)
					setHasContextAi(true)
				}
			}
		}
	}, [data, models, modelsConfig])

	useEffect(() => {
		if (!loading_template) {
			dispatch(uploadContextAiFile({ context: filePath }))
		}
	}, [dispatch, loading_template, filePath])

	const createDocumentVersion = (form) => {
		dispatch(newVersion({ id: data.id, description, text: textUpdate }))
		dispatch(setShowModal(false))
		form.resetFields()
	}

	const updateText = (text, comments) =>
		dispatch(updateTextVersion({ text, comments }))

	const downloadDocument = () => dispatch(downloadLink({ id: data.id }))

	const handlesendForSigning = () => {
		dispatch(sendForSigning({ id: data.id }))
	}

	const handleDescription = (form) => {
		dispatch(updateDescription(form.getFieldsValue()))
	}

	const handleCancelConnectModal = () => {
		dispatch(setShowConnectModal(false))
	}

	const getDocumentWord = () => {
		dispatch(
			getDocumentWordDownload({ id: data.id, filename: `${data.title}.docx` })
		)
	}

	const handleDownloadButton = () => {
		dispatch(getDocumentCertificate({ id: data.id }))
	}

	const handleInitialFolder = () => {
		dispatch(listContract())
		dispatch(setInitialFolder())
		history.push('/')
	}

	const handleFolderRowBack = (index) => {
		dispatch(setRollBackFolder(index))
		history.push('/')
	}

	const handleEditDocument = () =>
		history.push({
			pathname: `/documents/${data.id}/edit`,
		})

	const downloadVersionHandler = (event, item) => {
		event.stopPropagation()
		const versionInfo = {
			id: data.id,
			versionId: item.id,
			versionName: item.description,
			documentTitle: data.title,
			companyId: companyId,
			downloadFormat: data.download_format,
		}
		dispatch(downloadTextDocumentVersion(versionInfo))
	}

	const handleDownloadDocDifTypes = (event) => {
		if (data.text_type === '.txt') {
			if (data !== undefined) {
				downloadVersionHandler(event, data.versions[0])
			}
		} else {
			getDocumentWord()
		}
	}

	var listFolders = accessFolders.map((folder, index) => (
		<Breadcrumb.Item
			key={index}
			className={styles.breadcrumbs}
			onClick={() => handleFolderRowBack(index)}>
			{folder ? folder.title : null}
		</Breadcrumb.Item>
	))

	return (
		<MainLayout>
			<Layout
				style={{
					padding: '0',
					background: '#fff',
					width: '100%',
					height: '100%',
					overflow: 'hidden',
				}}>
				<PageHeader>
					<Breadcrumb>
						<Breadcrumb.Item
							onClick={handleInitialFolder}
							className={styles.breadcrumbs}>
							Documentos
						</Breadcrumb.Item>
						{accessFolders.length ? listFolders : null}
						<Breadcrumb.Item className={styles.breadcrumbs}>
							{data.title}
						</Breadcrumb.Item>
					</Breadcrumb>
					<HeaderButtons
						id={data.id}
						history={history}
						infos={data}
						baseDocument={baseDocument}
						onDownload={handleDownloadDocDifTypes}
						onUpdate={handleShowModal}
						textUpdate={textUpdate}
						version_id={version_id}
						text={text}
						loadingVersion={loadingVersion}
						hasContextAi={hasContextAi}
					/>
				</PageHeader>
				<NewVersionModal
					handleCancel={handleCancelModal}
					handleCreate={createDocumentVersion}
					showModal={showModal}
					description={description}
					handleDescription={handleDescription}
				/>
				<ConnectDocusignModal
					handleCancel={handleCancelConnectModal}
					showModal={showConnectModal}
				/>

				{Object.keys(data).length < 1 && <Spin spinning={loading} />}
				{Object.keys(data).length > 0 && (
					<div
						style={{
							display: 'flex',
							width: '100%',
							/* TODO: This is a temporary fix  */
							height: 'calc(100% - 108px)',
							columnGap: '10px',
							paddingBottom: '20px',
						}}>
						{data.draft ? (
							<DraftIndicator title={data.title} onClick={handleEditDocument} />
						) : file ? (
							<div
								style={{
									height: '100%',
									width: '100%',
								}}>
								<PdfReader url={file} />
							</div>
						) : (
							<Editor
								text={text}
								onUpdateText={updateText}
								block={
									loadingSign ||
									loading ||
									data.sent ||
									version_id !== data.versions[0].id
								}
								versionLoading={loadingVersion}
								title={data.title}
								ckeditorCss={data.ckeditor_css}
								ckeditorStyles={data.ckeditor_styles}
							/>
						)}
						<Tabs
							workflowContext={workflowContext}
							downloadDocument={getDocumentWord}
							signers={data.signers}
							infos={data}
							signed={data.signed}
							sent={data.sent}
							handleEditSigners={handleEditSigners}
							loadingSign={loadingSign}
							onClickDownload={downloadDocument}
							block={loadingSign || loading}
							downloadButton={handleDownloadButton}
							downloadVersionHandler={downloadVersionHandler}
							hasContextAi={hasContextAi}
							handlesendForSigning={handlesendForSigning}
							modelsConfig={modelsConfig}
							companyConfig={companyInfo.config}
						/>
					</div>
				)}
			</Layout>
		</MainLayout>
	)
}

export default DocumentDetails
